import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center" }

import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnIcon from "src/components/button/SfxBtnIcon.vue"
import SfxContextMenu from "src/components/navigation/SfxContextMenu.vue"
import { useConfigurationStore } from "src/stores/configurationStore"
import { useNotificationsStore } from "src/stores/notificationsStore"
import { ContextMenuItem } from "src/util/classes/contextMenuItem"
import { ContextAction } from "src/util/enums/entityType"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { showNotifications } from "src/util/functions/overlays"
import { computed, onUnmounted, PropType, ref, watch } from "vue"

//region Props and Emits

const animationInterval = 1000 // ms
const vibrationTimer = 1000 // ms

export default /*#__PURE__*/_defineComponent({
  __name: 'SfxContextBar',
  props: {
  quickAction: Number as PropType<ContextAction>,

  menuContent: Array as PropType<Array<ContextAction>>,

  disabledMenuContent: Array as PropType<Array<ContextAction>>,

  disableQuickAction: Boolean,

  disableMenu: Boolean,

  hideContextMenu: Boolean,

  disableNotifications: Boolean,

  hideNotifications: Boolean,

  hideSeparator: Boolean,
},
  emits: ["contextSelect"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const notificationsStore = useNotificationsStore()
const notificationCount = computed(() => notificationsStore.count)
const configurationStore = useConfigurationStore()
const enableAnimation = computed(() => configurationStore.animateNotification)

const quickActionItem = computed(() => {
  if (props.quickAction !== undefined) {
    const item = ContextMenuItem.getContextMenuItems([props.quickAction])
    if (item && item.length > 0) {
      return item[0]
    }
  }
  return null
})

const contextItems = computed(() => {
  return !props.menuContent
    ? ContextMenuItem.getContextMenuItems(undefined, props.disabledMenuContent)
    : ContextMenuItem.getContextMenuItems(props.menuContent, props.disabledMenuContent)
})

const animatedIconClass = computed(() => {
  return { invisible: !animationState.value }
})
const animationState = ref<boolean>(false)
let animationObject: ReturnType<typeof setInterval> | undefined

const vibrationState = ref<boolean>(false)
const vibrateClass = computed(() => {
  return { "vibrate-bell": vibrationState.value && !enableAnimation.value }
})

const bellIconOn = Icons.NOTIFICATIONS_NEW + " fa-stack-1x"
const bellIcon = Icons.NOTIFICATIONS + " fa-stack-1x"

//endregion

//region Lifecycle

onUnmounted(stopNotificationAnimation)

//endregion

//region Functions

function handleContextSelection(contextMenuItem: ContextMenuItem) {
  emit("contextSelect", contextMenuItem)
}

function stopNotificationAnimation() {
  clearInterval(animationObject)
  animationObject = undefined
  animationState.value = false
}

//endregion

//region Setup Code

watch(
  () => notificationCount.value && enableAnimation.value,
  () => {
    // Clear any lingering intervals
    if (animationObject) {
      stopNotificationAnimation()
    }

    // Start only if there are notifications
    if (notificationCount.value > 0 && enableAnimation.value) {
      animationObject = setInterval(
        () => (animationState.value = !animationState.value),
        animationInterval
      )
    }
  },
  { immediate: true }
)

watch(
  () => notificationCount.value,
  (newCount, oldCount) => {
    // Only vibrate if the number of notifications is increased
    if (newCount > oldCount) {
      vibrationState.value = true

      // Remove vibration class after X amount of seconds
      setTimeout(() => {
        vibrationState.value = false
      }, vibrationTimer)
    }
  }
)

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_badge = _resolveComponent("q-badge")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (quickActionItem.value)
      ? (_openBlock(), _createBlock(SfxBtnIcon, {
          key: 0,
          icon: quickActionItem.value.icon,
          disable: __props.disableQuickAction,
          class: "sfx-quick-action-icon",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleContextSelection(quickActionItem.value)))
        }, null, 8, ["icon", "disable"]))
      : _createCommentVNode("", true),
    (!props.hideContextMenu)
      ? (_openBlock(), _createBlock(SfxBtnIcon, {
          key: 1,
          icon: _unref(Icons).CONTEXT_MENU,
          disable: __props.disableMenu
        }, {
          default: _withCtx(() => [
            _createVNode(SfxContextMenu, {
              "context-menu-items": contextItems.value,
              onContextSelect: handleContextSelection
            }, null, 8, ["context-menu-items"])
          ]),
          _: 1
        }, 8, ["icon", "disable"]))
      : _createCommentVNode("", true),
    (!props.hideSeparator)
      ? (_openBlock(), _createBlock(_component_q_separator, {
          key: 2,
          vertical: "",
          inset: ""
        }))
      : _createCommentVNode("", true),
    (!props.hideNotifications)
      ? (_openBlock(), _createBlock(SfxBtn, {
          key: 3,
          flat: "",
          dense: "",
          round: "",
          size: "lg",
          disable: __props.disableNotifications,
          onClick: _unref(showNotifications)
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, [
              (!props.disableNotifications)
                ? (_openBlock(), _createBlock(_component_q_icon, {
                    key: 0,
                    name: bellIconOn,
                    class: _normalizeClass(["sfx-btn--animate", animatedIconClass.value])
                  }, null, 8, ["class"]))
                : _createCommentVNode("", true),
              _createVNode(_component_q_icon, {
                name: bellIcon,
                class: _normalizeClass(vibrateClass.value)
              }, {
                default: _withCtx(() => [
                  (!props.disableNotifications && notificationCount.value > 0)
                    ? (_openBlock(), _createBlock(_component_q_badge, {
                        key: 0,
                        color: "secondary",
                        floating: "",
                        rounded: "",
                        align: "bottom"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(notificationCount.value), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["class"])
            ])
          ]),
          _: 1
        }, 8, ["disable", "onClick"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})